/**
 * アカウント設定値APIクライアント（FKV3-13286）
 * バックエンドの /{accountCode}/app-settings を呼び出す
 */

import { apiGet } from './client';
import type { AccountAppSettingsView } from '@/lib/types/feature/account-app-setting';

/** アカウントのアプリ設定値を取得する（読み取り専用） */
export async function getAccountAppSettings(
  accountCode: string,
  authHeaders?: Record<string, string>,
): Promise<AccountAppSettingsView> {
  return apiGet<AccountAppSettingsView>(`/${accountCode}/app-settings`, authHeaders);
}
